import { render, staticRenderFns } from "./welcome_health_plus.vue?vue&type=template&id=0000649d&scoped=true"
import script from "./welcome_health_plus.vue?vue&type=script&lang=js"
export * from "./welcome_health_plus.vue?vue&type=script&lang=js"
import style0 from "./welcome_health_plus.vue?vue&type=style&index=0&id=0000649d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0000649d",
  null
  
)

/* custom blocks */
import block0 from "./welcome_health_plus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports